



















import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import { isPropertyInFlanders } from "@/shared/scripts/ValidateData";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect
    },
    data: function() {
        return {
            pathInStore: "transaction.certificates.epc.score"
        };
    },
    computed: {
        epcScore: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "APARTMENT", "GARAGE", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        isFlandersAddress: function(): boolean {
            return isPropertyInFlanders(
                this.$store.getters["FormModule/getValue"]("property.location.address.country"),
                this.$store.getters["FormModule/getValue"]("property.location.address.postalCode")
            );
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("undefined"),
                    "value": ""
                },
                // A++ is not a valid EPC value in Flanders (only Brussels and Wallonia)
                ...(this.isFlandersAddress ? [] : [{
                    "label": this.$t("A++"),
                    "value": "A++"
                }]),
                {
                    "label": this.$t("A+"),
                    "value": "A+"
                },
                {
                    "label": this.$t("A"),
                    "value": "A"
                },
                {
                    "label": this.$t("B"),
                    "value": "B"
                },
                {
                    "label": this.$t("C"),
                    "value": "C"
                },
                {
                    "label": this.$t("D"),
                    "value": "D"
                },
                {
                    "label": this.$t("E"),
                    "value": "E"
                },
                {
                    "label": this.$t("F"),
                    "value": "F"
                },
                {
                    "label": this.$t("G"),
                    "value": "G"
                },
                {
                    "label": this.$t("X"),
                    "value": "X"
                }
            ];
        }
    },
    watch: {
        isFlandersAddress: {
            immediate: true,
            handler: function(isFlanders: boolean): void {
                if (isFlanders && this.epcScore === "A++") {
                    this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": "A+"});
                }
            }
        }
    },
    methods: {
        updateValue: function(epcScoreValue: string): void {
            if (epcScoreValue === "") {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": epcScoreValue});
            }
        }
    },
});

